export const combineSearchParams = (basePath: string, parts: string[]) =>
  `/#!/${basePath}${parts.reduce((acc, part) => {
    // we should keep leading '?' at the beginning of the final string
    if (acc.length === 0) return part;

    return `${acc}${part.replace('?', '&')}`;
  }, '')}`;
